import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CopyIconModule } from '@components/copy-icon/copy-icon.module';
import { SiteInfoModule } from '@shared/components/site-info/site-info.module';
import { Icons } from '@shared/constants/icons';
import { DirectivesModule } from '@shared/directives/directives.module';
import { SizeDirective } from '@shared/directives/size.directive';
import { PipesModule } from '@shared/pipes/pipes.module';
import { BadgeComponent } from '@ui/badge/badge.component';
import { ButtonsModule } from '@ui/buttons/buttons.module';
import { DialogModule } from '@ui/dialog/dialog.module';
import { NotificationModule } from '@ui/notification/notification.module';
import { SvgRegistryService } from '@ui/svg/svg-registry.service';
import { SvgModule } from '@ui/svg/svg.module';
import { TooltipModule } from '@ui/tooltip/tooltip.module';
import { CopilotAskLauncherComponent } from './copilot-ask-launcher/copilot-ask-launcher.component';
import { FooterComponent } from './footer/footer.component';
import { LayoutComponent } from './layout.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PaymentOverdueBannerComponent } from './payment-overdue-banner/payment-overdue-banner.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatDialogModule,
    DirectivesModule,
    PipesModule,
    SiteInfoModule,
    DirectivesModule,
    DialogModule,
    SvgModule,
    NotificationModule,
    TooltipModule,
    CopyIconModule,
    SizeDirective,
    BadgeComponent,
    ButtonsModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    LayoutComponent,
    ProfileMenuComponent,
    PaymentOverdueBannerComponent,
    CopilotAskLauncherComponent,
  ],
  exports: [FooterComponent, LayoutComponent],
})
export class LayoutModule {
  constructor(private svgRegistryService: SvgRegistryService) {
    this.svgRegistryService.preload(Icons.Edit_24);
  }
}
